import * as React from 'react';

import { theme } from '../../styled';
import { IconProps } from './Icon';

export const TickIcon = ({ width, height, color }: IconProps) => {
  const DEFAULT_COLOR = theme.colors.primary.main;

  return (
    <svg
      fill={color || DEFAULT_COLOR}
      height={height}
      viewBox="0 0 12 10"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7212 0.961362C11.3499 0.589585 10.747 0.58982 10.3752 0.961362L4.31744 7.01936L1.62503 4.32697C1.25325 3.95519 0.650609 3.95519 0.278832 4.32697C-0.0929441 4.69874 -0.0929441 5.30139 0.278832 5.67316L3.6442 9.03854C3.82998 9.22431 4.07357 9.31743 4.31719 9.31743C4.5608 9.31743 4.80463 9.22454 4.9904 9.03854L11.7212 2.30753C12.0929 1.93602 12.0929 1.33311 11.7212 0.961362Z"
        fill={color || DEFAULT_COLOR}
      />
    </svg>
  );
};
